import * as React from 'react';

import {colors} from '../colors/colors';
import {WarningIcon} from '../icon/svg/warning-icon';
import {Popover} from '../popover/popover';
import {Body} from '../typography/body';
import {useRefObserver} from '../utils/hooks/use-ref-observer';

import styles from './warning.module.css';

type Props = {
    text: string | React.ReactNode;
    level?: 'normal' | 'error';
};

export function Warning(props: Props) {
    const {level = 'normal'} = props;

    const warningIconRef = React.useRef<HTMLDivElement | null>(null);
    const {isHovered} = useRefObserver(warningIconRef, ['isHovered']);

    const iconColor = level === 'error' ? colors.red : colors.orangeAttention;
    const popoverColor = level === 'error' ? 'error' : 'light';
    const bodyColor = level === 'error' ? 'white' : 'dark';

    return (
        <>
            <div id='wrapper' ref={(node) => (warningIconRef.current = node)}>
                {/* @ts-expect-error */}
                <WarningIcon size={16} color={iconColor} />
            </div>
            {isHovered && warningIconRef && (
                <Popover anchor={warningIconRef.current} location='bottom' bodyColor={popoverColor}>
                    <div className={styles.container}>
                        <Body color={bodyColor} size='small'>
                            {props.text}
                        </Body>
                    </div>
                </Popover>
            )}
        </>
    );
}
